import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { MapPin, Phone, Clock, Mail } from "lucide-react";
import { restaurantInfo } from "../../mock";

export default function ContactSection() {
  return (
    <section className="bg-sand py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="divider-ornament">Get In Touch</span>
          <h2 className="font-display text-sea-deep text-4xl md:text-5xl lg:text-6xl font-medium mt-5 mb-4 leading-[1.1]">
            Visit Us
          </h2>
          <p className="text-sea-mid/85 text-base md:text-lg">
            Find us in the heart of Frankston — we'd love to welcome you for a memorable evening.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-12">
          {[
            {
              icon: <MapPin size={22} />,
              title: "Address",
              lines: [restaurantInfo.address.line1, restaurantInfo.address.line2]
            },
            {
              icon: <Phone size={22} />,
              title: "Phone",
              lines: [restaurantInfo.phoneDisplay],
              link: `tel:${restaurantInfo.phone}`
            },
            {
              icon: <Mail size={22} />,
              title: "Email",
              lines: [restaurantInfo.email],
              link: `mailto:${restaurantInfo.email}`
            },
            {
              icon: <Clock size={22} />,
              title: "Hours",
              lines: ["Mon–Sun ·  6:30 AM – 11:30 PM"]
            }
          ].map((item) => (
            <div key={item.title} className="bg-white p-8 border border-sea-deep/8 text-center">
              <div className="w-12 h-12 rounded-full bg-sea-deep text-spice-gold flex items-center justify-center mx-auto mb-5">
                {item.icon}
              </div>
              <h4 className="font-display text-sea-deep text-xl mb-3">{item.title}</h4>
              {item.lines.map((line, idx) => (
                <div key={`${item.title}-${line}`} className="text-sea-mid/80 text-sm leading-relaxed">
                  {item.link && idx === 0 ? (
                    <a href={item.link} className="hover:text-spice-gold transition-colors">{line}</a>
                  ) : (
                    line
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/reservations">
            <Button className="bg-spice-gold hover:bg-[hsl(38_75%_46%)] text-[#0d2929] font-semibold tracking-wide rounded-none px-10 h-14">
              Reserve Your Table
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
